const ANDROID_APP_TARGETS = {
  'stage.front.marso.club': {
    appLinkHost: 'stage.front.marso.club',
    packageName: 'com.marso_club.app.dev',
  },
  'marso.club': {
    appLinkHost: 'marso.club',
    packageName: 'com.marso_club.app',
  },
  'www.marso.club': {
    appLinkHost: 'marso.club',
    packageName: 'com.marso_club.app',
  },
}

export function isAndroidUserAgent(userAgent) {
  return /Android/i.test(userAgent)
}

export function getAndroidAppTarget(urlValue) {
  const url = new URL(urlValue)

  if (url.protocol !== 'https:') {
    return null
  }

  return ANDROID_APP_TARGETS[url.hostname.toLowerCase()] ?? null
}

export function buildAndroidAppIntentUrl(
  urlValue,
  { includeBrowserFallback = true } = {},
) {
  const url = new URL(urlValue)
  const target = getAndroidAppTarget(urlValue)

  if (!target) {
    return null
  }

  const appUrl = `${target.appLinkHost}${url.pathname}${url.search}${url.hash}`

  const fallbackIntentPart = includeBrowserFallback
    ? `;S.browser_fallback_url=${encodeURIComponent(url.href)}`
    : ''

  return `intent://${appUrl}#Intent;scheme=https;package=${target.packageName}${fallbackIntentPart};end`
}
